import React, { useEffect, useState } from 'react';
import { listGroups, searchBanks, searchSupervisors } from '../api/banks';
import './ScopeSearchModal.css';

// Recherche d'un Group/Supervisor/Bank pour le filtre de scope (Sales Monitoring et
// autres pages de rapports partageant le meme radio All/Group/Supervisor/Bank).
const ScopeSearchModal = ({ filter, onSelect, onClose }) => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = (q) => {
    setLoading(true);
    const request =
      filter === 'Group' ? listGroups() :
      filter === 'Supervisor' ? searchSupervisors(q) :
      searchBanks(q);

    request
      .then((data) => setResults(
        filter === 'Group' && q
          ? data.filter(g => (g.display_name || g.name).toLowerCase().includes(q.toLowerCase()))
          : data
      ))
      .catch(() => setResults([]))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  const handleSearch = () => load(query);
  const handleKeyDown = (e) => { if (e.key === 'Enter') handleSearch(); };
  // `display_name` ("group1-1" = nom du group + son N°, Group.display_name cote
  // backend) n'existe que sur les lignes Group — les autres filtres
  // (Supervisor/Bank) retombent sur `name`/`username` comme avant.
  const label = (row) => row.display_name || row.name || row.username || `#${row.seq}`;

  return (
    <div className="ssm-overlay">
      <div className="ssm-modal">
        <div className="ssm-header">
          <span className="ssm-title">{filter}</span>
          <button className="ssm-close-btn" onClick={onClose}></button>
        </div>

        <div className="ssm-body">
          <div className="ssm-search-row">
            <input
              className="ssm-search-input"
              type="text"
              placeholder="Nom..."
              value={query}
              onChange={e => setQuery(e.target.value)}
              onKeyDown={handleKeyDown}
              autoFocus
            />
            <button className="ssm-search-btn" onClick={handleSearch}>Search</button>
          </div>

          <div className="ssm-table-wrapper">
            {loading ? (
              <p className="ssm-loading">Chargement...</p>
            ) : (
              <table className="ssm-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                  </tr>
                </thead>
                <tbody>
                  {results.map((row) => (
                    <tr
                      key={row.id}
                      className="ssm-row"
                      onClick={() => { onSelect(row.id, label(row), row.seq); onClose(); }}
                    >
                      <td>{row.seq}</td>
                      <td>{label(row)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>

        <div className="ssm-footer">
          <button className="ssm-cancel-btn" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default ScopeSearchModal;
